// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/nexus/agents/agents.actions.go

export const UPDATE_SERVICE_ACCOUNT =
  "mondoo.agents.AgentManager.UpdateServiceAccount";
